/* eslint-disable no-nested-ternary */
import { useState } from 'react';
import {
  Form, Input, Select, Button,
} from 'antd';
import classes from './index.module.css';

export const SHIPPING_CARRIER = [{
  value: 'USPS',
  label: 'USPS',
}, {
  value: 'UPS',
  label: 'UPS',
}, {
  value: 'FedEx',
  label: 'FedEx',
}, {
  value: 'DHL Express',
  label: 'DHL Express',
}, {
  value: 'GLS',
  label: 'GLS',
}, {
  value: 'Others',
  label: 'Others',
},
];

const trackNumberTest = (value) => /^(?=.*[0-9])[a-zA-Z0-9\s]+$/.test(value);

export default function TrackingForm({
  trackingNumber, handleSubmit, status, desc,
}) {
  const [disabled, setDisabled] = useState(true);

  const onValuesChange = (value, values) => {
    let flag = false;
    Object.values(values).forEach((item) => {
      if (!item) {
        flag = true;
      }
    });
    if (!trackNumberTest(values.trackingNumber)) {
      flag = true;
    }
    if (flag !== disabled) {
      setDisabled(flag);
    }
  };

  return (
    <div className={classes.ra_submit_title}>
      {trackingNumber ? (
        <div className={classes.stepContent}>
          {`Your return tracking number is ${trackingNumber}`}
        </div>
      ) : status !== 'In Progress' ? (
        <div>{desc}</div>
      ) : (
        <>
          <div>
            {'Your return request has been submitted, please add your return shipping information within '}
            <span className={classes.bold}>3</span>
            {' days.'}
          </div>
          <div className={classes.ra_submit}>Make sure the item(s) you are returning is in its original condition and package the item(s).</div>
          <div className={classes.return_address}>
            <div className={classes.return_title}>Return address:</div>
            <div>Seel Return Center</div>
            <div>566 Brannan St</div>
            <div>San Francisco, CA 94107</div>
            <div>United States</div>
          </div>
          <Form
            name="trackingForm"
            layout="vertical"
            onFinish={handleSubmit}
            onValuesChange={onValuesChange}
            className={classes.trackingForm}
          >
            <Form.Item
              name="trackingNumber"
              label="Tracking number"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'Please enter tracking number' }, {
                validator: (rule, value) => {
                  if (!value) {
                    return Promise.reject();
                  }
                  if (!value || (value && !trackNumberTest(value))) {
                    return Promise.reject(new Error('Please enter a valid tracking number'));
                  }
                  return Promise.resolve();
                },
              }]}
            >
              <Input style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item name="trackingCompany" label="Shipping carrier" style={{ marginBottom: 0 }}>
              <Select style={{ width: '100%' }} options={SHIPPING_CARRIER}>
              </Select>
            </Form.Item>
            <Button type="primary" disabled={disabled} htmlType="submit" className={classes.tracking_button}>Submit</Button>

          </Form>
        </>
      )}

    </div>

  );
}
